import { FC } from 'react'
import { Badge, IconButton } from '@mui/material'
import { MqttStatus } from '../../API/types'
import { DoorFront, MeetingRoom, Lock, LockOpenOutlined, DeviceThermostat, WaterDrop } from '@mui/icons-material'
import { makeStyles } from 'tss-react/mui'

interface IDL1ControllerStatusProps {
  controllerId: string
  mqttDeviceStatus?: MqttStatus | undefined
}

const useStyles = makeStyles()(() => ({
  badge: {
    fontSize: 9,
    height: 15,
    minWidth: 15,
    right: -7,
  },
}))

const DL1ControllerStatus: FC<IDL1ControllerStatusProps> = ({ controllerId, mqttDeviceStatus }) => {
  const { classes } = useStyles()

  //if (mqttDeviceStatus)
  //console.log(mqttDeviceStatus);

  return (
    <>
      <IconButton component='div' sx={{ cursor: 'default' }}>
        {mqttDeviceStatus && mqttDeviceStatus.lockStatus ? <LockOpenOutlined /> : <Lock />}
      </IconButton>
      <IconButton component='div' sx={{ cursor: 'default' }}>
        {mqttDeviceStatus && mqttDeviceStatus.doorStatus === 1 ? <MeetingRoom /> : <DoorFront />}
      </IconButton>
      <IconButton component='div' sx={{ cursor: 'default' }}>
        <Badge badgeContent={mqttDeviceStatus?.tempC} color={'success'} classes={{ badge: classes.badge }}>
          <DeviceThermostat />
        </Badge>
      </IconButton>
      <IconButton component='div' sx={{ cursor: 'default' }}>
        <Badge
          badgeContent={mqttDeviceStatus?.humidity ? mqttDeviceStatus?.humidity + '%' : undefined}
          color={'primary'}
          classes={{ badge: classes.badge }}
        >
          <WaterDrop />
        </Badge>
      </IconButton>
    </>
  )
}

export default DL1ControllerStatus
